module.exports = __webpack_public_path__ + "static/img/sec2-cont-@t.5acfa6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgwatersolution/sec2-cont-@t.png
// module id = 1+0h
// module chunks = 0